export default __webpack_public_path__ + "static/media/UNIVERSITY OF ILLINOIS.2a1c8660.png";